const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3001';

export const checkSalary = async (params) => {
  const { birthDate, startDate, endDate, startingYear } = params;
  try {
    const response = await fetch(`${API_BASE_URL}/api/salary/check`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${JSON.parse(localStorage.getItem('pocketbase_auth')).token}`  
      },
      body: JSON.stringify({ 
        birthDate, 
        startDate, 
        endDate,
        startingYear
      }),
    });
    
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.error || errorData.message || 'Échec du calcul de salaire');
    }
    
    // Traiter la réponse comme du JSON
    const result = await response.json();
    
    // Retourner directement le résultat du backend
    return {
      success: result.status === 'ok',
      message: result.message,
      data: result.data,
      // Informations sur les périodes de salaire
      ageInitial: result.data?.ageInitial,
      dateDebut: result.data?.dateDebut,
      dateFin: result.data?.dateFin,
      dureeContrat: result.data?.dureeContrat,
      periodes: result.data?.periodes,
      periodesDetaillees: result.data?.periodesDetaillees
    };
  } catch (error) {
    console.error('Erreur lors du calcul du salaire:', error);
    // Retourner un objet cohérent même en cas d'erreur
    return {
      success: false,
      message: error.message || 'Erreur lors du calcul du salaire'
    };
  }
};
